import { RedcatApiHandler } from 'polygon-utils';
export default function (...args: FetchParams[]) {
  //@ts-ignore
  return RedcatApiHandler.fetch(...args);
}
